<button
  [attr.type]="type"
  [class]="buttonClasses"
  [disabled]="disabled || loading"
  (click)="onClick($event)"
  class="flex items-center justify-center border gap-1.5 text-sm font-medium rounded-md py-[9.5px] px-3 cursor-pointer
         disabled:opacity-80 disabled:cursor-not-allowed"
>
  <!-- Icon (Always visible if set) -->
  <ng-container *ngIf="iconSrc">
    <img [src]="iconSrc" [alt]="iconAlt" class="shrink-0" [ngClass]="iconClass" [class.icon-white]="iconWhite" [attr.style]="iconWhite ? 'filter: brightness(0) invert(1)' : null" />
  </ng-container>

  <!-- Button Content -->

  <span class="text-nowrap leading-3" [class]="textClasses"><ng-content></ng-content></span>

  <!-- Spinner (Only when loading) -->
  <ng-container *ngIf="loading">
    <span [class]="spinnerClass" class="shrink-0 h-3 w-3 border-2 border-t-transparent rounded-full animate-spin"></span>
  </ng-container>
</button>
